import { PdHistoryItem } from "./PdHistoryItem.js";
//#region src/pd-history/pd-history-item.ts
var tag = "pd-history-item";
if (!customElements.get(tag)) customElements.define(tag, PdHistoryItem);
//#endregion
export { PdHistoryItem };
